import React from "react";
import { Field, ForkKnifeIcon, SectionHeader, TextInput } from "./CreateBlockFields";

const CateringDetails = ({
  cateringOwner, setCateringOwner,
  onsiteName, setOnsiteName,
  eventAttendees, setEventAttendees,
  functionType, setFunctionType,
  postAs, setPostAs,
}) => (
  <div className="col-md-12">
    <div className="cb-card">
      <SectionHeader icon={<ForkKnifeIcon />} title="Catering Details" />
      <div className="cb-card-body">
        <div className="grid-row">
          <Field label="Catering Owner" required className="col-6"><TextInput disabled value={cateringOwner} onChange={(event) => setCateringOwner(event.target.value)} /></Field>
          <Field label="Onsite Name" className="col-6"><TextInput placeholder="Primary point of contact" value={onsiteName} onChange={(event) => setOnsiteName(event.target.value)} /></Field>
        </div>
        <div className="grid-row">
          <Field label="Event Attendees" className="col-6"><TextInput placeholder="Estimated headcount" value={eventAttendees} onChange={(event) => setEventAttendees(event.target.value)} /></Field>
          <Field label="Function Type" className="col-3"><TextInput value={functionType} onChange={(event) => setFunctionType(event.target.value)} /></Field>
          <Field label="Post As" className="col-3" info><TextInput value={postAs} onChange={(event) => setPostAs(event.target.value)} /></Field>
        </div>
      </div>
    </div>
  </div>
);

export default CateringDetails;